import React, { useEffect, useState } from "react";
import { Field, Formik } from "formik";
import * as yup from "yup";
import { TabView, TabPanel } from "primereact/tabview";
import { Checkbox } from "primereact/checkbox";
import { Card } from "react-bootstrap";
import { getCustomerAddress } from "../../../../../services/sales/customerService";
import {
  onPreventEnterSubmitting,
  setObject,
} from "../../../../../utils/utils";
import { DialogActions } from "@material-ui/core";
import { Editor } from "primereact/editor";
import {
  CustomDatePickerField,
  CustomTextField,
} from "../../../../../partials/content/Forms";
import SoAddress from "../../salesOrder/salesOrderForm/soAddress";
import SoTOC from "../../salesOrder/salesOrderForm/soTOC";
import store from "../../../../../store/store";
import { useGlobalData } from "../../../../../../provider/GlobalDataProvider";
import { DateTime } from "luxon";
function ConvertToSalesOrderForm({
  salesCardID = 0,
  quotation = { ID: 0, customerID: 0, leadID: 0, note: "", toc: "" },
  salesOrderTOCs,
  customerAddressDefault,
  handleCustomerAddressDefault,
  customerTOCDefault,
  handleCustomerTOCDefault,
  salesOrderTOCDefault,
  onConfirmSave,
  onCloseDialog,
  onBackDialog,
}) {
  const { socket } = useGlobalData();
  const [customerAddresses, setCustomerAddresses] = useState([]);
  let quotationToSo = {
    salesCardID,
    customerType: quotation.customerID > 0 ? 2 : 1,
    quotationID: quotation.ID,
    leadID: quotation.leadID,
    customerID: quotation.customerID,
    customerPoNo: "",
    expDeliveryDate: DateTime.now()
      .endOf("day")
      .plus({ days: 7 }),
    triggerSOapproval: false,
    note: quotation.note,
    tocName: {},
    toc: salesOrderTOCDefault,
    soBillingAddressID: 0,
    soBillingAddress: {
      addressID: 0,
      address: quotation.address,
      countryCode: quotation.countryCode,
      postalCode: quotation.postalCode,
      city: quotation.city,
      province: quotation.province,
      addressPhone: quotation.addressPhone,
      addressEmail: quotation.addressEmail,
    },
    soDeliveryAddressID: 0,
    soDeliveryAddress: {
      addressID: 0,
      address: quotation.address,
      countryCode: quotation.countryCode,
      postalCode: quotation.postalCode,
      city: quotation.city,
      province: quotation.province,
      addressPhone: quotation.addressPhone,
      addressEmail: quotation.addressEmail,
    },
  };

  const quotationToSoSchema = yup.object().shape({
    quotationID: yup.number(),
    soBillingAddress: yup.object().shape({
      address: yup
        .string()
        .required("Address is required")
        .max(255, "Address maximum characters is 255"),
      city: yup
        .string()
        .required("City is required")
        .max(50, "City maximum characters is 50"),
      addressPhone: yup
        .string()
        .matches(
          /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,3})|(\(?\d{2,6}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/,
          "Phone Number must be valid. e.g. +6281XXXXXXX or 081XXXXXXX"
        )
        .max(50, "Phone Number maximum characters is 50"),
      addressEmail: yup
        .string()
        .email("Email must be valid. e.g. joe@invifo.com")
        .max(50, "Email maximum characters is 50"),
      province: yup.string().max(50, "Province maximum characters is 50"),
      countryCode: yup.string(),
      postalCode: yup.string().max(10, "Postal Code maximum characters is 10"),
    }),
    soDeliveryAddress: yup.object().shape({
      address: yup
        .string()
        .required("Address is required")
        .max(255, "Address maximum characters is 255"),
      city: yup
        .string()
        .required("City is required")
        .max(50, "City maximum characters is 50"),
      addressPhone: yup
        .string()
        .matches(
          /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,3})|(\(?\d{2,6}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/,
          "Phone Number must be valid. e.g. +6281XXXXXXX or 081XXXXXXX"
        )
        .max(50, "Phone Number maximum characters is 50"),
      addressEmail: yup
        .string()
        .email("Email must be valid. e.g. joe@invifo.com")
        .max(50, "Email maximum characters is 50"),
      province: yup.string().max(50, "Province maximum characters is 50"),
      countryCode: yup.string(),
      postalCode: yup.string().max(10, "Postal Code maximum characters is 10"),
    }),
  });

  useEffect(() => {
    const { auth } = store.getState();

    if (quotation && quotation.ID > 0) {
      setObject(socket, "lock", quotation.ID, "QUCN", auth.user)
        .then((response) => {
          if (quotation.customerID > 0) {
            getCustomerAddressesData(quotation.customerID);
          }
        })
        .catch((error) => {
          onCloseDialog();
        });
    }
    return () => {
      if (quotation && quotation.ID > 0) {
        setObject(socket, "release", quotation.ID, "QUCN", auth.user);
      }
    };
  }, [quotation]);

  return (
    <Formik
      initialValues={quotationToSo}
      enableReinitialize={true}
      validateOnChange={false}
      validationSchema={quotationToSoSchema}
      onSubmit={async (values, { resetForm, setStatus, setSubmitting }) => {
        onConfirmSave(values);
      }}
    >
      {({
        values,
        status,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        isSubmitting,
      }) => (
        <form
          autoComplete="off"
          className="kt-form"
          onSubmit={handleSubmit}
          onKeyDown={onPreventEnterSubmitting}
        >
          <div className="tabview">
            <div className="card">
              <TabView className="tabview" scrollable>
                <TabPanel header="Sales Order Main" rightIcon="fas fa-th-large">
                  <div className="row">
                    <div className="col-sm-12 col-md-12 col-lg-12">
                      <Card>
                        <Card.Header>
                          <i className="fas fa-window-maximize"></i>
                          <span>
                            <strong>Sales Order Header</strong>
                          </span>
                        </Card.Header>
                        <Card.Body>
                          <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-12">
                              <CustomTextField
                                label="Customer PO Number"
                                inputType="text"
                                propertyName="customerPoNo"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                values={values}
                                touched={touched}
                                errors={errors}
                                size="small"
                              />
                              <Field
                                name="expDeliveryDate"
                                label="Expected Delivery Date"
                                margin="normal"
                                touched={touched}
                                disablePast={true}
                                disableFuture={false}
                                component={CustomDatePickerField}
                                size="small"
                              />
                              <div className="p-field-checkbox my-3">
                                <Checkbox
                                  icon="pi pi-check-circle"
                                  inputId="triggerSOapproval"
                                  checked={values.triggerSOapproval}
                                  onChange={(e) => {
                                    setFieldValue(
                                      "triggerSOapproval",
                                      e.checked
                                    );
                                  }}
                                />
                                <label htmlFor="triggerSOapproval">
                                  Trigger Sales Order Approval
                                </label>
                              </div>
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    </div>
                  </div>
                </TabPanel>
                <TabPanel header="Addresses" rightIcon="fas fa-map-marked-alt">
                  <div className="row">
                    <div className="col-sm-6 col-md-6 col-lg-6 mb-3 mb-md-0">
                      <SoAddress
                        customerAddresses={customerAddresses}
                        values={values}
                        addressType="soBilling"
                        customerAddressDefault={customerAddressDefault}
                        onCustomerAddressDefault={handleCustomerAddressDefault}
                        setFieldValue={setFieldValue}
                      />
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <SoAddress
                        customerAddresses={customerAddresses}
                        values={values}
                        addressType="soDelivery"
                        customerAddressDefault={customerAddressDefault}
                        onCustomerAddressDefault={handleCustomerAddressDefault}
                        setFieldValue={setFieldValue}
                      />
                    </div>
                  </div>
                </TabPanel>
                <TabPanel
                  header={`Note, Terms & Conditions`}
                  rightIcon="fas fa-sticky-note"
                >
                  <div className="row mb-3">
                    <div className="col-sm-12 col-md-12 col-lg-12">
                      <Card>
                        <Card.Header>
                          <i className="fas fa-sticky-note"></i>
                          <span>
                            <strong>Note</strong>
                          </span>
                        </Card.Header>
                        <Card.Body>
                          <Editor
                            style={{ height: "200px", width: "100%" }}
                            onTextChange={(e) => {
                              setFieldValue("note", e.htmlValue);
                            }}
                            value={values.note}
                            placeholder="Type your notes here..."
                          />
                        </Card.Body>
                      </Card>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12 col-md-12 col-lg-12">
                      <SoTOC
                        salesOrderTOCs={salesOrderTOCs}
                        customerTOCDefault={customerTOCDefault}
                        handleCustomerTOCDefault={handleCustomerTOCDefault}
                      />
                    </div>
                  </div>
                </TabPanel>
              </TabView>
            </div>
          </div>
          <DialogActions>
            <button
              type="button"
              className="btn btn-label-danger btn-md btn-pill btn-bold"
              onClick={onCloseDialog}
            >
              <i className="fas fa-window-close"></i>
              Cancel
            </button>
            {values.customerType === 2 ? null : (
              <button
                type="button"
                className="btn btn-label-warning btn-md btn-pill btn-bold"
                onClick={onBackDialog}
              >
                <i className="fas fa-arrow-circle-left"></i>
                Back
              </button>
            )}
            <button
              type="submit"
              className="btn btn-success btn-md btn-pill btn-bold"
              disabled={isSubmitting}
            >
              <i className="fas fa-save"></i>
              Convert
            </button>
          </DialogActions>
        </form>
      )}
    </Formik>
  );

  async function getCustomerAddressesData(customerID) {
    const responseAddress = await getCustomerAddress(customerID);
    const { data } = responseAddress.data;
    setCustomerAddresses(data.addresses);
  }
}

export default ConvertToSalesOrderForm;
